
var $ = require('jquery');
var Backbone = require('backbone');
var DateTime = require('DateTime');

var ReservaPriceTableView = Backbone.View.extend({

	events: {
		'click .offset-down': 'offsetDown',
		'click .offset-up': 'offsetUp',
		'click .btn-reset': 'reset',
		'click .count-up': 'countUp',
		'click .count-down': 'countDown',
		'mouseover a.price': 'priceHover',
		'click a.price': 'clickPrice',
	},

	initialize: function() {
		this.listenTo(this.model, "change:viewData", this.render);
	},

	render: function() {
		this.el.innerHTML = TemplateCache.render('pricetable-template', this.model.get("viewData"));
	},

	/*
	 Event Handler
	*/

	offsetDown: function(e) {
		var days = $(e.currentTarget).data('days') | 0;
		this.model.setRenderOffset(this.model.get("renderOffset") - days);
	},

	offsetUp: function(e) {
		var days = $(e.currentTarget).data('days') | 0;
		this.model.setRenderOffset(this.model.get("renderOffset") + days);
	},

	reset: function(e) {
		this.model.setRenderOffset(0);
	},

	countDown: function(e) {
		this.model.set("renderDaysCount", Math.max(10, this.model.get("renderDaysCount") - 5));
	},

	countUp: function(e) {
		this.model.set("renderDaysCount", this.model.get("renderDaysCount") + 5);
	},

	priceHover: function(e) {
		var data = $(e.currentTarget).data();
		data.to = DateTime.parse(data.from).add(this.model.get("nights"), "days").format("YYYY-MM-DD");

		var args = {
			from: data.from,
			to: data.to,
		};

		/* A gorgeous hack to integrate the crappy old IBE. Should be neither hard-coded nor in this view. */
		if ( typeof window.ReservaForm !== "undefined" ) {
			args.rooms = ReservaForm.get("rooms");
			args.erwachsene_1 = ReservaForm.get("erwachsene_1");
			args.kinder_1 = ReservaForm.get("kinder_1");
			args.kind1_1 = ReservaForm.get("kind1_1");
			args.kind2_1 = ReservaForm.get("kind2_1");
			args.kind3_1 = ReservaForm.get("kind3_1");
			args.erwachsene_2 = ReservaForm.get("erwachsene_2");
			args.kinder_2 = ReservaForm.get("kinder_2");
			args.kind1_2 = ReservaForm.get("kind1_2");
			args.kind2_2 = ReservaForm.get("kind2_2");
			args.kind3_2 = ReservaForm.get("kind3_2");
			args.erwachsene_3 = ReservaForm.get("erwachsene_3");
			args.kinder_3 = ReservaForm.get("kinder_3");
			args.kind1_3 = ReservaForm.get("kind1_3");
			args.kind2_3 = ReservaForm.get("kind2_3");
			args.kind3_3 = ReservaForm.get("kind3_3");
			args.item = ReservaForm.get("item");
			args.currency = ReservaForm.get("currency");
			args.lang = ReservaForm.get("lang");
		}

		e.currentTarget.href = data.url + '?' + $.param(args);
	},

	clickPrice: function(e) {
		/* If we're inside the old IBE, do nothing and let the browser handle the link */
		if ( window.ReservaForm ) return;
		e.preventDefault();

		var data = $(e.currentTarget).data();
		data.to = DateTime.parse(data.from).add(this.model.get("nights"), "days").format("YYYY-MM-DD");

		this.model.trigger("pricetableClick", {
			href: e.currentTarget.href,
			from: data.from,
			to: data.to,
		});
	},

});

module.exports = ReservaPriceTableView;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/pricetable/ReservaPriceTableView.js
 **/